import type { Permission } from '@/domains/permission/types';
import type { Component } from 'vue';

export enum PAGE_TYPE {
    ENTRY = 'entry',
    PAGE = 'page',
    TOOL = 'tool',
}

export interface RouterConfig {
    type: PAGE_TYPE,
    name: string,
    exclusiveRoutePath: string,
    getComponent: () => Promise<{ default: Component }>,
    /** 布局组件，默认使用 MainLayout */
    getLayout?: () => Promise<{ default: Component }>,
}

export interface ToolConfig {
    label: string,
    icon: string,
    tabIndex: number,
    aclCheckPath?: (permission: Permission) => boolean,
}

export interface Manifest extends RouterConfig, Partial<ToolConfig> {}
